import api from '@/utils/api';

const defaultState = {
  variantId: null,
  variantSku: null,
  priceLists: [],
  pricing: [],
  productData: null,
  productLoading: false,
  productNotFound: false,
  pricingLoading: [],
};

export default {
  namespaced: true,
  state: { ...defaultState },
  getters: {
    currentVariant(state) {
      return state.productData
        ? state.productData.variants.find((variant) => variant.id === state.variantId)
        : null;
    },
  },
  mutations: {
    setVariantId(state, id) {
      state.variantId = id;
    },

    setVariantSku(state, sku) {
      state.variantSku = sku;
    },

    setPriceLists(state, data) {
      state.priceLists = data;
    },

    setPricing(state, data) {
      state.pricing = data;
    },

    updatePricing(state, data) {
      data.forEach((updatedPriceList) => {
        const priceListIndex = state.pricing.findIndex(
          (statePriceList) => statePriceList.price_list_slug === updatedPriceList.price_list_slug,
        );

        if (updatedPriceList.pricing.length === 0) {
          state.pricing.splice(priceListIndex, 1);
        } else {
          state.pricing[priceListIndex].pricing = updatedPriceList.pricing;
        }
      });
    },

    addPriceListPricing(state, data) {
      state.pricing.push(data);
    },

    deletePriceListPricing(state, priceListSlug) {
      const index = state.pricing.findIndex(
        (priceList) => priceList.price_list_slug === priceListSlug,
      );
      state.pricing.splice(index, 1);
    },

    setProductData(state, data) {
      state.productData = data;
    },

    setProductLoading(state, status) {
      state.productLoading = status;
    },

    setProductNotFound(state, status) {
      state.productNotFound = status;
    },

    setPricingLoading(state, priceListSlug) {
      const index = state.pricingLoading.findIndex((slug) => slug === priceListSlug);
      if (index) {
        state.pricingLoading.splice(index, 1);
      } else {
        state.pricingLoading.push(index);
      }
    },

    clearState(state) {
      state.variantId = defaultState.variantId;
      state.variantSku = defaultState.variantSku;
      state.priceLists = defaultState.priceLists;
      state.pricing = defaultState.pricing;
      state.productData = defaultState.productData;
      state.productLoading = defaultState.productLoading;
      state.productNotFound = defaultState.productNotFound;
      state.pricingLoading = defaultState.pricingLoading;
    },
  },
  actions: {
    async setVariant({
      commit, state, rootState,
    }, id) {
      commit('setVariantId', id);
      commit('setVariantSku', id);
      commit('setProductLoading', true);
      commit('setProductNotFound', false);

      try {
        const variant = await api.post(`/${rootState.env.data.environment}/proxy-api`, {
          method: 'GET',
          url: '/v1/variants/{id}',
          params: { id },
        });

        if (id === variant.data.sku) {
          commit('setVariantId', variant.data.id);
        }

        if (variant.data.sku) {
          commit('setVariantSku', variant.data.sku);
        }

        const product = await api.post(`/${rootState.env.data.environment}/proxy-api`, {
          method: 'GET',
          url: '/v1/products/{id}',
          params: { id: variant.data.product_id },
        });

        commit('setProductData', product.data);
      } catch (err) {
        commit('setProductNotFound', true);
      }

      try {
        const pricingData = (await api.post(`/${rootState.env.data.environment}/proxy-api`, {
          method: 'GET',
          url: '/v1/pricing/{id}',
          params: {
            id: state.variantSku,
          },
        }));

        commit('setPricing', pricingData.data);
      } catch (err) {
        commit('setProductNotFound', true);
      } finally {
        commit('setProductLoading', false);
      }
    },

    async getPriceLists({ commit, rootState }) {
      const priceLists = await api.post(`/${rootState.env.data.environment}/proxy-api`, {
        method: 'GET',
        url: '/v1/price-lists',
      });

      commit('setPriceLists', priceLists.data);
    },

    async updatePriceListPricing({ commit, rootState, state }, data) {
      commit('setPricingLoading', data.price_list_slug);

      const pricingData = (await api.post(`/${rootState.env.data.environment}/proxy-api`, {
        method: 'PATCH',
        url: '/v1/pricing/{id}',
        params: {
          id: state.variantSku,
        },
        body: [data],
      }));

      commit('updatePricing', pricingData.data);
      commit('setPricingLoading', data.price_list_slug);
    },
  },
};
